module.exports = __webpack_public_path__ + "img/small-3.721d46f2.webp";